<template>
    <ResultsNetworkBanner bannerType="warning" header="In network">
        <ApplicationTier :result="result" :tierLabel="currentPlanTierLabel" v-if="currentPlanIsTiered && result.tier" />
        <span>This plan covers emergency dental care only, not preventative dental care.</span>
    </ResultsNetworkBanner>
</template>
    
<script setup>

const props = defineProps({
        result: Object,
        rank: Number
    })
    const { currentPlanTierLabel, currentPlanIsTiered } = useFCPModel()

</script>
